<template>
  <div>
    <p class="mb-3">Which of the following <b>neutral</b> species is not a radical?</p>

    <v-form @submit.prevent="submitResponse">
      <v-radio-group v-model="inputs.input1" :disabled="!allowEditing">
        <v-radio
          v-for="option in options"
          :key="option.value"
          class="d-inline-block"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'Question325',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      // Put a list of inputs or computed properties here to be sent for marking

      inputs: {
        input1: null,
      },
      options: [
        {text: '$\\ce{NO}$', value: 'NO'},
        {text: '$\\ce{OH}$', value: 'OH'},
        {text: '$\\ce{ClO2}$', value: 'ClO2'},
        {text: '$\\ce{NO2}$', value: 'NO2'},
        {text: '$\\ce{SO}$', value: 'SO'},
      ],
    };
  },
};
</script>
